import React, { Suspense, useLayoutEffect, useMemo } from 'react';
import { Dialog, DialogContent } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import { themeConstructorV2 } from './theme/theme';

import { connect, useSelector } from 'react-redux';
import * as UIActions from './redux/actions/ui.actions';
import * as Selectors from './redux/selectors';
import AlertComponent from './components/popupAlerts/AlertComponent';
import Header from './components/dialog/Header';
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';
import Global from './components/dialog/Global';
import Router from './router.jsx';
import Loading from './pages/Loading.jsx';

const ThemeWrapper = (props) => {
  const { primaryColor, fontFamily, darkTheme } = props.preferences;
  const materialTheme = themeConstructorV2(primaryColor, fontFamily, darkTheme);
  useLayoutEffect(() => {
    ClassNameGenerator.configure((componentName) => `hotglue-w-${componentName}`);
  }, []);

  if (!props.initializationFinished) return <div></div>;
  return (
    <ThemeProvider theme={materialTheme}>
      <Global />
      <DialogComponent {...props} />
    </ThemeProvider>
  );
};
const DialogComponent = ({ navigation, preferences, configuration, flows, classes, company, ...props }) => {
  const { open, page, title, breadcrumbs } = navigation;
  const { width, height } = useSelector(Selectors.getDialogSize);

  const onClose = UIActions.closeWidget;
  // Keep track of last page for transitions
  const noPaddingX = useMemo(() => page === 'ConnectParams', [page]);

  return (
    <Dialog
      key={'widget-dialog'}
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={onClose}
      PaperProps={{
        sx: {
          pt: !company && page === 'AvailableFlows' ? 4 : 0,
          borderRadius: 4,
          maxWidth: width,
          height: height,
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'hidden',
        },
      }}
    >
      <AlertComponent />
      <Header title={title} onClose={onClose} />
      <DialogContent
        dividers
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          borderTop: 'initial',
          borderBottom: 'initial',
          py: 'initial',
          px: noPaddingX ? '0px' : '24px',
        }}
      >
        {/* {configuration.breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />} */}
        <Suspense fallback={<Loading />}>
          <Router page={page} />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (state, props) => {
  return {
    navigation: state.navigation,
    preferences: state.preferences,
    configuration: state.configuration,
    flows: state.flows,
    availableTargets: state.availableTargets,
    sources: state.sources,
    initializationFinished: Selectors.initializationFinished(),
    company: state.preferences.company,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeWrapper);
